import React from "react";
import styles from "../../asset/About/About.module.scss";

const LeaveImpressionAbout = () => {
  return (
    <section className={styles.aboutSection}>
      <div className={styles.container}>
        <div className={styles.left}>
          <h2 className={styles.title}>Leave an impression!</h2>
          <p>
            Sai Digitizing is the story of three individuals brought together by a shared vision: to build a company that leverages their combined strengths in the ITES and outsourcing space to deliver professional-quality graphic design and digitizing solutions to clients worldwide.
          </p>
          <p>
           This vision also had a deeper purpose — to create a workplace that fosters a symbiotic relationship with clients, encourages talent, initiative, and ownership, promotes a strong work ethic, and cultivates an ecosystem that values commitment and performance.
          </p>
          <p>Founded in January 2018, Sai Digitizing is a specialist provider of camera-ready artwork, embroidery digitizing, namedrop, and print design services for the promotional products, sportswear, photography, and print and publishing industries.</p>
        </div>

        <div className={styles.right}>
          <p>
            Sai Digitizing brings together years of industry experience, a skilled team of in-house designers and digitizers, state-of-the-art tools and techniques, professional workflow processes, and detail-oriented quality assurance systems to deliver custom design solutions—even within challenging turnaround times.
          </p>

          <p>
            A successful business enterprise on a strong growth trajectory, Sai Digitizing combines an onshore marketing office in the U.S. with multiple offshore production centers in India. This enables the delivery of a comprehensive range of custom design solutions, supported by responsive customer service and business-friendly pricing—helping clients achieve the best possible outcomes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LeaveImpressionAbout;
